import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CheckCircle2, Loader2, MinusCircle, AlertTriangle, Sparkles } from "lucide-react";

const ICON = { done: <CheckCircle2 className="w-4 h-4 text-emerald-600" />, reused: <CheckCircle2 className="w-4 h-4 text-emerald-500" />, running: <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />, pending: <MinusCircle className="w-4 h-4 text-slate-300" />, skipped: <MinusCircle className="w-4 h-4 text-slate-400" />, error: <AlertTriangle className="w-4 h-4 text-amber-600" /> };
const TXT = { done: "✓ analysé", reused: "✓ récent, réutilisé", running: "en cours…", pending: "en attente", skipped: "non applicable", error: "échec" };

// Orchestration centrale « Analyser mon établissement » : une action, toutes les analyses, progression lisible.
export const AnalyzeAllProgress = ({ estId, onDone }) => {
  const [run, setRun] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!run || run.status === "done") return undefined;
    const t = setInterval(async () => {
      try { const { data } = await api.get(`/establishments/${estId}/analyze-all/${run.id}`); setRun(data); if (data.status === "done") { toast.success("Analyse globale terminée"); onDone?.(); } } catch { /* ignore */ }
    }, 2500);
    return () => clearInterval(t);
  }, [run, estId, onDone]);
  const start = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/establishments/${estId}/analyze-all`); const r = await api.get(`/establishments/${estId}/analyze-all/${data.run_id}`); setRun(r.data); }
    catch { toast.error("Impossible de lancer l'analyse globale"); }
    finally { setBusy(false); }
  };
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-4" data-testid="analyze-all">
      <div className="flex items-center gap-3 flex-wrap">
        <div className="flex-1 min-w-[200px]"><div className="font-heading font-bold">Analyser mon établissement</div><p className="text-xs text-slate-500">Site, performance, SEO, visibilité IA, concurrence : tout est lancé en une fois. Les analyses récentes sont réutilisées.</p></div>
        <Button onClick={start} disabled={busy || (run && run.status !== "done")} className="rounded-xl bg-blue-600 hover:bg-blue-700" data-testid="analyze-all-button">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Sparkles className="w-4 h-4 mr-1" /> Tout analyser</>}</Button>
      </div>
      {run && (
        <div className="mt-3" data-testid="analyze-all-progress">
          <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-blue-600 transition-[width] duration-500" style={{ width: `${run.progress_pct}%` }} /></div>
          <ul className="mt-2 grid sm:grid-cols-2 gap-1 text-sm">{run.steps.map((s) => <li key={s.key} className="flex items-center gap-2" data-testid={`analyze-step-${s.key}`}>{ICON[s.status]}<span className="flex-1">{s.label}</span><span className="text-xs text-slate-500">{TXT[s.status]}{s.error ? ` · ${s.error}` : ""}</span></li>)}</ul>
        </div>
      )}
    </div>
  );
};
